import React, { useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import styles from './PopupCancelable.module.css';
import MensajeGrabando from './MensajeGrabando';

ReactModal.setAppElement('#root');

const PopupCancelable = (props) => {
  const texto = props.texto;
  const visible = props.visible;
  const popupHeightDesktop = props.height || '18rem';
  const popupWidthDesktop = props.width || '28rem';
  const eliminar = props.mostrarEliminar;
  const isGrabando = props.isGrabando;
  const [esMobile, setEsMobile] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => {
      setEsMobile(window.innerWidth < 600);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Ajustar dimensiones según viewport
  let popupWidth, popupHeight;
  if (esMobile) {
    // Mobile: 90% del ancho, altura máxima 80vh
    popupWidth = 'calc(90vw - 2rem)';
    popupHeight = 'auto';
  } else if (window.innerWidth < 1024) {
    // Tablet: 85% del ancho
    popupWidth = 'calc(85vw - 2rem)';
    popupHeight = popupHeightDesktop;
  } else {
    // Desktop: dimensiones originales
    popupWidth = popupWidthDesktop;
    popupHeight = popupHeightDesktop;
  }

  const aceptarHandler = (event) => {
    event.preventDefault();
    props.onAceptar();
  };

  const cancelarHandler = (event) => {
    event.preventDefault();
    props.onCancelar();
  };

  const eliminarHandler = (event) => {
    event.preventDefault();
    props.onEliminar();
  };

  return (
    <ReactModal
      isOpen={visible}
      onRequestClose={cancelarHandler}
      contextLabel={texto}
      overlayClassName={styles.overlay}
      className={`${styles.popup}`}
    >
      <form>
        <div
          className={`${styles.contenedor}`}
          style={{ width: popupWidth, height: popupHeight, maxHeight: esMobile ? '80vh' : 'auto' }}
        >
          <div className={`${styles.texto}`}>{texto}</div>
          {props.children}
        </div>
        <div className={`${styles.botonera}`}>
          <div className={`${styles.botoneraEliminar}`}>
            {eliminar && (
              <button
                className={`${styles.botonEliminar}`}
                onClick={eliminarHandler}
                disabled={isGrabando}
              >
                Eliminar
              </button>
            )}
          </div>
          <MensajeGrabando isGrabando={isGrabando} />
          <div className={`${styles.botoneraEditar}`}>
            <button onClick={cancelarHandler} disabled={isGrabando}>
              Cancelar
            </button>
            <button type="submit" onClick={aceptarHandler} disabled={isGrabando}>
              OK
            </button>
          </div>
        </div>
      </form>
    </ReactModal>
  );
};

export default PopupCancelable;
